import React from "react";
import fp from "lodash/fp";
import cx from "classnames";
import useSheet from "react-jss";
import PropTypes from "prop-types";
import { compose, withState } from "recompose";
import {
  Button,
  Checkbox,
  ToggleButton,
  ToggleButtonGroup
} from "react-bootstrap";

import Dialog from "./Dialog";

const loremIpsum = [
  "Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, qui dolorem eum fugiat, quo voluptas nulla pariatur?",
  "Duis aute irure dolor in reprehenderit in voluptate, qui blanditiis praesentium voluptatum deleniti atque corrupti, quos dolores et quas molestias excepturi sint, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.",
  "Lorem ipsum dolor sit amet, quis nostrum exercitationem ullam corporis suscipit laboriosam, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.",
  "Lorem ipsum dolor sit amet, qui in ea voluptate velit esse, quam nihil molestiae consequatur, vel illum, facere possimus, omnis voluptas assumenda est, omnis dolor repellendus.",
  "Excepteur sint occaecat cupidatat non proident, qui blanditiis praesentium voluptatum deleniti atque corrupti, quos dolores et quas molestias excepturi sint, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "Lorem ipsum dolor sit amet, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque..."
];

const enhancer = compose(
  useSheet({
    "@global": {
      "*, *::before, *::after": { boxSizing: "border-box" },
      "html, body, #root": {
        margin: 0,
        padding: 0,
        width: "100%",
        height: "100%",
        fontSize: "15px",
        lineHeight: "24px",
        WebkitFontSmoothing: "antialiased",
        fontFamily: '"Roboto", "sans-serif"'
      },
      "h1, h2, h3, h4, h5, h6": { margin: 0 },
      "::-ms-clear": { display: "none" },
      "input:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 1000px white inset"
      }
    },
    root: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "-ms-flex-direction": "column"
    },
    msDisplay: {
      display: "-ms-flexbox"
    },
    flex: {
      flex: "1 1 0%",
      "-ms-flex": "1 1 0%"
    },
    row: {
      flex: "none",
      display: "flex"
    },
    col: {
      flex: "1 1 0%",
      margin: "6px 0",
      "-ms-flex": "1 1 0%",
      flexDirection: "column",
      "-ms-flex-direction": "column",
      "& .btn.btn-default.active": {
        zIndex: 0
      }
    },
    container: {
      paddingTop: "50px",
      textAlign: "center"
    }
  }),
  withState("state", "setState", {
    title: "Title",
    showClose: false,
    loremIpsum: 0
  })
);

App.propTypes = {
  classes: PropTypes.object,

  state: PropTypes.object,
  setState: PropTypes.func
};

function App(props) {
  const { classes, state } = props;
  const dialogContent = [];

  for (let i = 0; i < state.loremIpsum || i > loremIpsum.length; i++) {
    dialogContent.push(<p key={i}>{loremIpsum[i]}</p>);
  }

  return (
    <div className={classes.container}>
      <Button
        bsStyle="primary"
        onClick={() => props.setState(fp.set("open", true))}
      >
        Open Modal
      </Button>

      <Dialog
        open={state.open}
        title={state.title}
        position={state.position}
        alignActions={state.align}
        showCloseButton={state.showClose}
        onRequestClose={() => props.setState(fp.unset("open"))}
      >
        <div className={cx(classes.row, classes.msDisplay)}>
          <div className={classes.col}>
            <span>Dialog Title: </span>
            <br />
            <input
              id="title"
              type="text"
              value={state.title}
              onChange={e => props.setState(fp.set("title", e.target.value))}
            />

            <Checkbox
              checked={state.showClose}
              onChange={() => props.setState(fp.update("showClose", x => !x))}
            >
              Show Close Button
            </Checkbox>
          </div>
          <div className={classes.col}>
            <span>Align Actions:</span>
            <br />
            <ToggleButtonGroup
              type="radio"
              name="align"
              defaultValue="end"
              value={state.align}
              onChange={a => props.setState(fp.set("align", a))}
            >
              <ToggleButton value="start">Left</ToggleButton>
              <ToggleButton value="center">Center</ToggleButton>

              <ToggleButton value="end">Right</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <div className={cx(classes.row, classes.msDisplay)}>
          <div className={classes.col}>
            <span>Modal Position:</span>
            <br />
            <ToggleButtonGroup
              type="radio"
              name="position"
              defaultValue="center"
              value={state.position}
              onChange={p => props.setState(fp.set("position", p))}
            >
              <ToggleButton value="top-left">Top Left</ToggleButton>
              <ToggleButton value="top-center">Top Center</ToggleButton>
              <ToggleButton value="top-right">Top Right</ToggleButton>

              <ToggleButton value="center-left">Center Left</ToggleButton>
              <ToggleButton value="center">Center</ToggleButton>
              <ToggleButton value="center-right">Center Right</ToggleButton>

              <ToggleButton value="bottom-left">Bottom Left</ToggleButton>
              <ToggleButton value="bottom-center">Bottom Center</ToggleButton>
              <ToggleButton value="bottom-right">Bottom Right</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <div className={cx(classes.row, classes.msDisplay)}>
          <div className={classes.col}>
            <div className={cx(classes.row, classes.msDisplay)}>
              <div className={classes.col}>
                <Button
                  onClick={() =>
                    props.setState(fp.update("loremIpsum", x => x + 1))
                  }
                  disabled={state.loremIpsum >= 7}
                >
                  Add Text
                </Button>
              </div>

              <div className={classes.col}>
                <Button
                  bsStyle="primary"
                  onClick={() => props.setState(fp.set("secondModal", true))}
                >
                  Second Modal
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className={cx(classes.row, classes.msDisplay)}>
          <div className={classes.col}>{dialogContent}</div>
        </div>
      </Dialog>
      <Dialog
        title="Second Modal"
        position="bottom-left"
        open={state.secondModal}
        onRequestClose={() => props.setState(fp.unset("secondModal"))}
      >
        Second Modal
      </Dialog>
    </div>
  );
}

export default enhancer(App);



// WEBPACK FOOTER //
// ./src/components/App.js